import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ToastWrapper = () => {
    return (
        <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
            toastClassName="!rounded-lg !shadow-lg !border !border-slate-200 !p-0 !mb-3"
            bodyClassName="!p-4 !m-0"
            progressClassName="!bg-indigo-600"
            style={{
                "--toastify-color-success": "#10b981",
                "--toastify-color-error": "#ef4444",
                "--toastify-color-warning": "#f59e0b",
                "--toastify-color-info": "#3b82f6",
            }}
        />
    );
};

export default ToastWrapper;

